import CloseController from '../../controllers/CloseController';
import { DailyQuest } from './DailyQuest';
import QuestDailyController from '../../controllers/quest/QuestDailyController';
import { QuestClaim } from './QuestClaim';
import { COMPONENTS } from '../../lib/constants';
import MainGridController from '../../controllers/grid/MainGridController';
import { QuestPageGrid } from './QuestPageGrid';
import QuestPageController from '../../controllers/quest/QuestPageController';
import QuestClaimController from '../../controllers/quest/QuestClaimController';
import UiConstants from '../../lib/UIconstants';

export const QuestPageClaim = {
	name: COMPONENTS.QUEST_PAGE_CLAIM,
	child: true,
	zIndex: 2,
	position: {
		x: 0,
		y: 0
	},
	controllers: [
		{
			Controller: CloseController,
			name: 'CloseController',
			config: {
				closeBtn: 'close',
				remove: true
			}
		},
		{
			Controller: QuestDailyController,
			name: 'QuestDailyController',
			config: {
				item: 'quest_daily',
				val: 'quest_daily',
				btns: [UiConstants.FTR_QUEST_GO, 'daily_btn']
			}
		},
		{
			Controller: MainGridController,
			name: 'QuestPageGrid',
			config: QuestPageGrid
		},
		{
			Controller: QuestPageController,
			name: 'QuestPageController',
			config: {
				holder: 'quest_view_holder_up',
				name: 'quest_claim'
			}
		},
		{
			Controller: QuestClaimController,
			name: 'QuestClaimController',
			config: {
				id: 1,
				item: 'quest_claim_1',
				img: 'quest_reward_icon_1',
				quests: [
					'quest_claim_1',
					'quest_claim_2',
					'quest_claim_3',
					'quest_claim_4'
				]
			}
		},
		{
			Controller: QuestClaimController,
			name: 'QuestClaimController',
			config: {
				id: 2,
				item: 'quest_claim_2',
				img: 'quest_reward_icon_2',
				quests: [
					'quest_claim_1',
					'quest_claim_2',
					'quest_claim_3',
					'quest_claim_4'
				]
			}
		},
		{
			Controller: QuestClaimController,
			name: 'QuestClaimController',
			config: {
				id: 3,
				item: 'quest_claim_3',
				img: 'quest_reward_icon_5',
				quests: [
					'quest_claim_1',
					'quest_claim_2',
					'quest_claim_3',
					'quest_claim_4'
				]
			}
		},
		{
			Controller: QuestClaimController,
			name: 'QuestClaimController',
			config: {
				id: 4,
				item: 'quest_claim_4',
				img: 'quest_reward_icon_4',
				quests: [
					'quest_claim_1',
					'quest_claim_2',
					'quest_claim_3',
					'quest_claim_4'
				]
			}
		}
	],
	components: [
		{
			name: 'quest_view_holder_up',
			type: 'Sprite',
			components: [
				{
					name: 'bg',
					type: 'Sprite',
					img: 'reel_bg',
					position: { x: 0, y: 0 },
					alpha: 0.6
				},
				{
					name: 'bg_border',
					type: 'Sprite',
					img: 'reel_border',
					position: { x: -20, y: -20 }
				},
				{
					name: 'quest_page_secondary_bg',
					type: 'Sprite',
					img: 'quest_page_secondary_bg',
					position: { x: 34, y: 272 }
				},
				{
					name: 'quest_featured_img',
					type: 'Sprite',
					img: 'quest_featured_img',
					position: { x: 16, y: 54 }
				},
				{
					name: 'header',
					type: 'CustomText',
					text: 'QUEST_DAILY_HEADER',
					position: { x: 1144 / 2 + 15, y: 30 },
					anchor: {
						x: 0.5,
						y: 0
					}
				},
				{
					name: 'close',
					type: 'Button',
					components: [
						{
							name: 'bg',
							type: 'MouseOverSprite',
							img: 'close_icon',
							imgHover: 'close_icon_hovered',
							position: { x: 1050, y: 15 }
						}
					]
				},
				{
					name: 'quest_daily',
					position: { x: 53, y: 0 },
					type: 'VisualComponent',
					component: DailyQuest
				},
				{
					name: 'quest_claim_1',
					position: { x: 58, y: 306 },
					type: 'VisualComponent',
					component: QuestClaim
				},
				{
					name: 'quest_claim_2',
					position: { x: 323, y: 306 },
					type: 'VisualComponent',
					component: QuestClaim
				},
				{
					name: 'quest_claim_3',
					position: { x: 586, y: 306 },
					type: 'VisualComponent',
					component: QuestClaim
				},
				{
					name: 'quest_claim_4',
					position: { x: 850, y: 306 },
					type: 'VisualComponent',
					component: QuestClaim
				}
			]
		}
	]
};
